import { render, staticRenderFns } from "./EcoBlockAnchor.vue?vue&type=template&id=d7015d86&"
import script from "./EcoBlockAnchor.vue?vue&type=script&lang=js&"
export * from "./EcoBlockAnchor.vue?vue&type=script&lang=js&"
import style0 from "./EcoBlockAnchor.vue?vue&type=style&index=0&id=d7015d86&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports